import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Button, ButtonType, ButtonVariant, FormBuilder, FormField, IconColor, IconName, IconSize, Input, InputState, usePrevious, } from '@as/cotopaxi';
export const initialValuesContentOverviewForm = {
    contentSearch: '',
};
const SearchChangeHandler = ({ initialValues, contentSearch, onChange, }) => {
    const prevContent = usePrevious(contentSearch);
    useEffect(() => {
        if (prevContent !== contentSearch && initialValues.contentSearch !== contentSearch) {
            onChange(contentSearch);
        }
    }, [contentSearch, onChange, prevContent, initialValues]);
    return null;
};
export const ContentOverviewForm = ({ initialValues, onSubmit, onSearchChange, handleResetValues, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    return (_jsx(FormBuilder, { onSubmit: onSubmit, initialValues: initialValues, name: "content-overview-form", children: ({ errors, touched, values, setValues }) => (_jsxs(_Fragment, { children: [_jsx(SearchChangeHandler, { initialValues: initialValues, onChange: onSearchChange, contentSearch: values.contentSearch }), _jsx(FormField, { name: "contentSearch", placeholder: t('flyout.search.placeholder'), state: errors.contentSearch && touched.contentSearch && InputState.ERROR, adornmentEnd: _jsxs(_Fragment, { children: [values.contentSearch && !errors.contentSearch && (_jsx(Button, { noBubble: true, onClick: () => {
                                    setValues(initialValuesContentOverviewForm);
                                    handleResetValues();
                                }, variant: ButtonVariant.TRANSPARENT_SUBTLE, icon: { name: IconName.CLOSE, size: IconSize.MEDIUM } })), _jsx(Button, { type: ButtonType.SUBMIT, variant: values.contentSearch && !errors.contentSearch ? ButtonVariant.BASE : ButtonVariant.TRANSPARENT, icon: {
                                    name: IconName.MAGNIFY,
                                    size: IconSize.MEDIUM,
                                    color: !values.contentSearch || errors.contentSearch ? IconColor.SUBTLE : null,
                                } })] }), Component: Input })] })) }));
};
